var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.updateLoading)?_c('div',{staticClass:"loading-update"},[_vm._v("\n    loading...\n    "),_c('van-loading',{staticStyle:{"display":"inline-block"},attrs:{"color":"black"}})],1):_vm._e(),_vm._v(" "),(_vm.dataEnd)?_c('p',{staticClass:"message_bottom"},[_vm._v("我是有底线的~")]):_vm._e()])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-f8105200","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/updateLoading.vue
// module id = null
// module chunks = 